Application.Signature.PreviewList = {
    ui: {
        iconlist: {
            container: '.js-iconlist.step-preview__iconlist-container',
            list: '.step-preview__iconlist',
            icon: '.iconlist__link'
        },
        categories: {
            container: '.step-preview__categories',
            link: '.categories__link'
        },
        preview: {
            container: '.preview',
            content: '.preview__content',
            zoomIn: '.preview__zoom-in',
            zoomOut: '.preview__zoom-out',
        },
        input: '.preview__list-input'
    },
    handlers: {
        ready: null,
        change: null,
        reset: null,
        zoom: null
    },
    ready: function () {

        if (!$(this.ui.iconlist.container).length){
            return;
        }

        // bind events
        this.bind();

        // init
        this.init();

    },
    init: function(){

        // size preview
        var $preview = $(this.ui.preview.container);
        if ($preview.is('.preview_resizable')){
            var width = $preview.data('width');
            var height = $preview.data('height');
            $preview.css('max-width', (height / width > 0.75 ? (75 * width / height) + '%' : width + 'px'));
            $preview.find(this.ui.preview.content).css('padding-top', Math.round(100 * height / width) + '%');
        }

        // select first icon
        var $active = $(this.ui.iconlist.icon).filter('.iconlist__link_active').length ? $(this.ui.iconlist.icon).filter('.iconlist__link_active') : $(this.ui.iconlist.list).filter(':not(.step-preview__iconlist_disabled)').find(this.ui.iconlist.icon).first();
        this.icon($active.data('id'), $active.data('preview-src'), $active.data());

        // callback
        if (typeof this.handlers.ready === 'function'){
            this.handlers.ready();
        }

    },
    bind: function(){

        var self = this;

        // categories
        $(document).on('click', this.ui.categories.link, function(event){
            event.preventDefault();
            self.category($(this).data('category-id'));
        });

        // icons
        $(document).on('click', this.ui.iconlist.icon, function(event){
            event.preventDefault();
            self.icon($(this).data('id'), $(this).data('preview-src'), $(this).data());
        });

        // zoom
        $(document).on('click', this.ui.preview.zoomIn, function(event){
            event.preventDefault();
            self.zoomIn();
        });
        $(document).on('click', this.ui.preview.zoomOut, function(event){
            event.preventDefault();
            self.zoomOut();
        });

    },
    category: function(id){

        var $categories = $(this.ui.categories.link);
        var $iconlist = $(this.ui.iconlist.list);

        // link
        $categories.removeClass('categories__link_active');
        $categories.filter('[data-category-id="' + id + '"]').addClass('categories__link_active');

        // list
        $iconlist.removeClass('step-preview__iconlist_active');
        $iconlist.filter('[data-category-id="' + id + '"]').addClass('step-preview__iconlist_active');

    },
    icon: function(id, src, data){

        // link
        var $icons = $(this.ui.iconlist.icon);
        $icons.removeClass('iconlist__link_active');
        $icons.filter('[data-id="' + id + '"]').addClass('iconlist__link_active');

        // input
        $(this.ui.input).val(id);

        // callback
        if (typeof this.handlers.change === 'function'){
            this.handlers.change(id, src, data);
        }

    },
    reloadIcon: function(){

        var id = $(this.ui.input).val();
        var $icon = $(this.ui.iconlist.icon).filter('[data-id="' + id + '"]');

        this.icon(id, $icon.data('preview-src'), $icon.data());

    },
    reset: function(){

        if (typeof this.handlers.reset === 'function'){
            this.handlers.reset();
        }

    },
    zoomIn: function(){

        $(this.ui.preview.container).addClass('preview_zoomed-in');
        this.handlers.zoom(1.5);

    },
    zoomOut: function(){

        $(this.ui.preview.container).removeClass('preview_zoomed-in');
        this.handlers.zoom(1);

    },
    setOnReady: function(handler){

        this.handlers.ready = handler;

    },
    setOnChange: function(handler){

        this.handlers.change = handler;

    },
    setOnZoom: function(handler){

        this.handlers.zoom = handler;

    },
    setOnReset: function(handler){

        this.handlers.reset = handler;

    }
}